import { trackPageRequest } from './appComponents/shared/PageLoadingService';
import { authenticatedPut } from './appComponents/shared/AuthenticatedAPI';
import Amplify, { Auth, Storage, API } from 'aws-amplify'
import { ReactSearchAutocomplete } from 'react-search-autocomplete'

import './../styles/Browser.css'; // Tell webpack that Button.js uses these styles
import './../index.css';
import React, {Component, Fragment, useRef, useLayoutEffect} from 'react';
import ErrorBoundary from '../utilities/ErrorBoundary.js';
import { Mosaic, OrbitProgress, ThreeDot } from "react-loading-indicators";

import {isMobile} from 'react-device-detect';

import { Chart } from 'react-google-charts';

import awsconfig from '../aws-exports.js';
import { navigationHandler, routeProps } from '../utilities/navigator.js';
import LoadingIcons from 'react-loading-icons'
import LeftNavBar  from '../components/LeftNavBar.js';
import blenderPrivateKey  from '../blenderData/generalPrivateKey.js';
import { tokenLifeTimeLimit, checkValidAuthTokenIntervalPeriod_ms,  LENDERBLOCKADMINWHITELIST} from '../blenderData/securityConfigurations.js';
import { Link, useParams } from 'react-router-dom';
import 'semantic-ui-css/semantic.min.css'
import {  
  Button, 
  ButtonContent,
  ButtonGroup,
  Modal, 
  Header, 
  Image, 
  Container,
  ListList,
  ListItem,
  ListIcon,
  Icon,
  ListHeader,
  ListDescription,
  ListContent,
  List,
  FormField, 
  Form, 
  Radio,
} from 'semantic-ui-react';
import { ethers } from 'ethers';
// var PrivateKeyProvider = require("truffle-privatekey-provider");
import axios from 'axios';

import blenderCommissionPublicKey from '../blenderData/blenderCommissionPublicKey.js';
import blenderTransfersToPublicKey from '../blenderData/blenderTransfersToPublicKey.js';

import CampaignContract_latest from '../ethereum/build/latest/Campaign.json';
import CampaignFactoryContract_latest from '../ethereum/build/latest/CampaignFactory.json';
import BrowserMobileRender from './browser/BrowserMobileRender.jsx';
import BrowserDesktopRender from './browser/BrowserDesktopRender.jsx';

const PrivateKeyProvider = null; // legacy provider reference retained; original require was already disabled

var primaryLanguage;
var mode_light_dark;

const Web3 = require('web3');
const CryptoJS = require("crypto-js");

var AWS = require('aws-sdk');

var mimemessage = require('mimemessage');

Amplify.configure(awsconfig);
Auth.configure(awsconfig);

var checkValidAuthTokenInterval;

var cognitoID;
var currentUser;
var currentUserCap;


var primaryDisplayCurrency;
var secondaryDisplayCurrency;
var publicKey;
var corporateBackedUsernamesArray;
var emailAddress;
var that;

let applicantUsername;
let isSubscribedCurrentBool = false;


var newMemberRegisterBool;

var addedContracts = []
var blenderData;
var userWishlist = [];
var preSortedContractsArray = []
var allContracts;
var username_wallet;
var allContractsLooper;

var filterSwitchReloaded;
var retrievedContractsArray
var creditLineArray;
let creditLineAddressArray;
var wishlistArray;
var recentlyViewedContractsArray;
var recentlyViewedContracts;
var topMoversArray;
var loanAgreementArray;
var walletBalanceWei;

var bScoreFilterMax, ratingMax, intRateMax, lenderCtMax;
var bScoreFilterMin, ratingMin, intRateMin, lenderCtMin;

let scrollHeaderInterval;

var publicKey
var rand1;
var rand2;
var rand3;
var rand4;
var randSum;
var filterSwitch;
var chartDayRange = 90

let mediaMapArrayUserMap = {}


let searchTimer;



 


let lastNonce;
var USDEtherConversionRate;
var tokenID;
var cognitoID;
var publicKey;
var privateKey;
let cardEntryFormTimer;
let exitFundWalletTimer;
let firstName ;
let lastName;
let fullAddress;
let postalCode; 
let fullName;
let street;
let city;
let state;
let country;
let resultMessageTimer;
let cardFundComponent;
let countryCodes;
let countryNames;
let countryCodeSwappedJSONList;
let optionCountryCodeSwappedJSON;
let countryCodeSwappedJSON;
let proposeGasPrice;



const debounce = require('lodash/debounce');

var PIXELAJUST = 725;


var web3;
var highRateWeb3;

var privateKey;
var pageOrigin;

var allValues
var chartData
var rand1; 
var rand2;
var rand3;
var rand4;
var allDaysElapsed;
var joinDateSecs;
var openContracts;
var totalBorrContracts 
var blenderScore 
var notificationCount
var lenders
var notifs
var chartDayRange;
var compoundedDebtSum;
var currentLentSum;

let stakedContractsList;
let primaryDisplayPrice;
let secondaryDisplayPrice;
let forexJSON;


var walletBalance;
var cognitoID;
var currentUserCap;



var squareCustomerID;

var corporateBackedUsernamesArray;

var openBorrowingContractsDetails_loanAgreement = []
var openLendingContractsDetails_loanAgreement = []
var openStakingContractsDetails_loanAgreement = []

var addedContracts_creditLine = []
var addedContracts_loanAgreement = []

var noAccountsWarning_creditLine;
var noAccountsWarning_loanAgreement;

var exitTutorialTimer_3, exitTutorialTimer_2, exitTutorialTimer_1;
var buttonColorFlashIntervalDefault;
var flashCounter = 0;

let mediaArray;
let mediaArrayMap;

var fundWalletPromptDidBool = false;
let verifyOverlayShownBool = false;


let monthLengtheningEnum = {
    JAN: 'January',
    FEB: 'February',
    MAR: 'March',
    APR: 'April',
    MAY: 'May',
    JUN: 'June',
    JUL: 'July',
    AUG: 'August',
    SEP: 'September',
    OCT: 'October',
    NOV: 'November',
    DEC: 'December',
}

let allBorrowerUsernamesDisplayNames = []


let cachedHomeState = null;

// Read the collateral-backed credit enforced by Campaign.createRequest.
// A failed read is unknown, never a substitute liquidity-based balance.
async function readOnChainAvailableCredit(campaign) {
  try {
    const creditABI = [{
      constant: true,
      inputs: [],
      name: 'availableCredit',
      outputs: [{name: '', type: 'uint256'}],
      payable: false,
      stateMutability: 'view',
      type: 'function'
    }];
    const creditContract = new web3.eth.Contract(creditABI, campaign.options.address);
    const wei = await creditContract.methods.availableCredit().call();
    return (Number(wei) / 1e18).toFixed(2);
  } catch (error) {
    console.warn('On-chain available credit read failed:', error?.message || error);
    return '';
  }
}

class BrowserComponent extends Component {

    constructor() {
      super()


    
      this.state = {
          usernameText: '',
          passwordText: '',
          touched: false,
          navigationDestinationObject: {
            navigationRoute: '',
          },
          passwordIsHiddenBool: true,
          button_recentApp_opacity: 1,
          button_pendingApp_opacity: 1,
          pendingApplicationsList: [],
          requestedAwaitingDocumentList: [],
          messageLineArray: [],
          submittedDocumentIDList: [],
          ableToFinalizeAndApproveBool: false,
          clientCorrespondenceMsgTextString: '',
          applicantUserFirstName: null,
          showLoaderOverlay: false,
          overheadApplicationApprovalString: '',
          applicationApprovedStatus: false,
          applicantUserFirstName: '',
          applicantEmailAddress: '',
          applicantUsername: '',
          messageInflight: false,
          didMessageSend: false,
          walletBalance: 0,
          compoundedDebtSum: 0, 
          currentLentSum: 0,
          moneyTransactionPreset: 'deposit',
          moneyTransactionLiveValue: null,
          creditLineArray: [],
          recentlyViewedContractsArray: [],
          wishlistArray: [],
          searchResultContracts: [],
          searchedContractsArray: [],
          searchSubmitted: false,
          searchLookupFailed: false,
          search: null, 
          moneyTransferOverlay: false,


          welcomeOverlay: false,
          socialOverlay: false,
          mediaMapArrayUserMap: {},
          mediaMapArray: [],
          socialOverlayData_username: '',
          socialOverlayData_fullName: '',
          socialOverlayData_imageURI: null,
          socialOverlayData_bioString: '',
          socialOverlayData_contractAddress: null,
          commentReplyID: null,
          commentInitMediaFileName: null,
          commentIsWritingMediaFileName: null,
          newCommentStringInput: null,
          commentViewerMediaFileName: null,
          likedMediaItemMap: {},
          subscriberBenefitsArray: [],

          inviteOverlay: false,
          emailAddress_phoneNumber: null,
          last4AccountNumbers_bankAccount: null,


          successfulDepositOverlay: false,
          successfulTransferOverlay: false,
          successfulWithdrawalOverlay: false,
          destinationUsername: null,
          currentUserProfilePicture: null,
          selectedLanguage: null,
          mode_light_dark: null,

          socialOverlay: false,
          socialOverlayData_username: null,
          socialOverlayData_fullName: null,
          socialOverlayData_imageURI: null,
          socialOverlayData_bioString: null,
          socialOverlayData_contractAddress: null,
          mediaMapArray: null,
          appearanceMode: 'dark',
          currentUser: null,
          errorTags: null,
          searchActivityBool: false,
          pendingTransactionLoaderOverlay: false,
          transferCommissionPercentDecimal: 0.05,

          walletBalanceUSD: 0,
          walletBalanceWei: 0,
          maxWalletWithdrawalWei: 0,

          verifyIDOverlay: false,
          showSearchDropDownMenuBool: false,
          allBorrowerUsernamesDisplayNames: [],
          allUserUsernamesDisplayNames: [],
          activeSearchBorrowerAccountBool: false,
          activeSearchTransferBool: false,
          navigationOverlay: false,
      };
      that = this

      
      

      newMemberRegisterBool = false;

      web3 = new Web3(new Web3.providers.HttpProvider("https://rpc.gnosischain.com/"));
      highRateWeb3 = new Web3(new Web3.providers.HttpProvider("https://rpc.gnosis.gateway.fm"));

  }

  componentWillUnmount(){
    cachedHomeState = {
    ...this.state,
    navigationDestinationObject: {
        navigationRoute: '',
    },
};
  }

  toggleTouched = () => {
      that.setState( prevState => ({
      touched: !prevState.touched
      }));
  }
  
  handleMouseUp = () => {
      // Handle smooth animation when clicking without holding
      setTimeout( () => {
      that.setState({ touched: false });
      }, 150);
  }


  
  resetSearch(){
    that.setState({ searchedContractsArray: [], searchResultContracts: [], searchSubmitted: false, searchActivityBool: false, searchLookupFailed: false })
  }

  performSearch(){
    let searchedUsername = String(that.state.search || '').trim().toLowerCase()
    let searchedContractsArray = [], contractAddressResponse
    let searchedContractsLooper;
    let searchContent;
    let commentsMap;
    let offeredLenderCommissionUSD_adjusted;
    let _offeredLenderCommissionUSD_adjusted;
    let targetValue;
    let whitelist;
    let availableCredit_unadjusted;

      if (searchedUsername.length < 2) {
        that.setState({searchedContractsArray: [], searchResultContracts: [], searchSubmitted: false, searchActivityBool: false});
        return;
      }
      clearTimeout(searchTimer);
      that.setState({
        searchedContractsArray: [],
        searchResultContracts: [],
        searchSubmitted: true,
        searchLookupFailed: false,
        searchActivityBool: true,
      })

      searchTimer = setTimeout(() => {
        that.setState({ 
          searchResultContracts: [],
          searchedContractsArray: [],
          searchActivityBool: false,
          searchLookupFailed: true,
        })
      }, 30000);



      authenticatedPut('api1169ba1e', '', { 
        headers: { Authorization: `Bearer ${cognitoID}` },
        body: { 
          category: 'db', 
          tableName: 'contractLookup', 
          primaryKey: searchedUsername, 
          requestOperation: 'get',
        }
      }).then(contractLookupResponse => {
        return authenticatedPut('api1169ba1e', '', { 
          headers: { Authorization: `Bearer ${cognitoID}` },
          body: { 
            category: 'db',
            tableName: 'username_contract', 
            primaryKey: searchedUsername, 
            requestOperation: 'get',
          }
        }).then(_contractAddressResponse => {


          let contractAddressResponse;
          // Search the exact username's credit-line mappings, not whichever rows
          // happen to be loaded into the All Active Accounts list.
          const mapped = _contractAddressResponse && _contractAddressResponse.Item
            ? _contractAddressResponse.Item.contractAddress : null;
          const direct = contractLookupResponse && contractLookupResponse.Item
            ? contractLookupResponse.Item.contractAddress : null;
          const rawAddresses = searchedUsername.startsWith('0x') && searchedUsername.length === 42
            ? [searchedUsername]
            : (Array.isArray(mapped) ? mapped : mapped ? [mapped] : direct ? [direct] : []);
          contractAddressResponse = rawAddresses
            .map((address) => String(address || '').trim())
            .filter((address) => /^0x[0-9a-fA-F]{40}$/.test(address) && !/^0x0{40}$/i.test(address))
            .filter((address, i, addresses) => addresses.findIndex(a => a.toLowerCase() === address.toLowerCase()) === i);
          searchedContractsLooper = contractAddressResponse.length;
          if (searchedContractsLooper > 0) {
            
            let currentDay = parseInt(Date.now()/86400000)
            let timeArray = [], searchedContracts = []
            

            for(let t=currentDay; t>=currentDay-chartDayRange; t--){
              timeArray.unshift(t)
            }
              
            for(let i=0; i<=contractAddressResponse.length-1; i++){
              let contractBoxColor, contractBoxBorderColor;
              let contributions = [], contributionAvg, contributionSum, valueDeltas = 0, walletUser, blenderScore, userAvgRating, manager, lookupKey, intRate, totalContributed, balance, lenderCt, availableCredit; 
              let contractStructure, isCorporateBondBool, offeredLenderCommissionUSD, managerDisplay; 
              let scopedContractLength = contractAddressResponse[i].length
              let scopedContract;

              if(searchedUsername.length == 42){
                scopedContract = searchedUsername.toLowerCase() 
              } else {
                scopedContract = contractAddressResponse[i]
              }

              let addedListCheck = searchedContracts.includes(contractAddressResponse[i])
              let _i = i;

              if(
                scopedContract != "0x0000000000000000000000000000000000000000" &&
                addedListCheck == false &&
                scopedContractLength == 42
              ){


                let campaign = new web3.eth.Contract( 
                  CampaignContract_latest.abi,
                  scopedContract
                );

                campaign.methods.getSummary1().call()
                  .then(async (res) => {

                    let web3BalancePost = String(res[0])
                    let loanTarget = String(res[1])
                    let finalRequestsSum = String(res[4])
                    let repaymentSum = String(res[5])
                    let lenderCt = Number(res[7])
                    let insuranceTotal = res[12]
                    


                    availableCredit = await readOnChainAvailableCredit(campaign)
          
                    searchedContracts.push(scopedContract)

                    let addedContractAddress = []

//////////////////////////////////////////////////////





                                        
                    let campaign = new web3.eth.Contract( 
                      CampaignContract_latest.abi,
                      scopedContract
                    );

                    campaign.methods.getSummary1().call()
                      .then(async (res) => {
                          
                          let web3BalancePost = String(res[0])
                          let loanTarget = String(res[1])
                          let finalRequestsSum = String(res[4])
                          let repaymentSum = String(res[5])
                          let insuranceTotal = res[12]

                          lenderCt = Number(res[7])

                          availableCredit_unadjusted = ((((Number(loanTarget) - Number(finalRequestsSum) + Number(repaymentSum))) / 1000000000000000000))

                            

                    availableCredit = await readOnChainAvailableCredit(campaign)
                          addedContracts.push(scopedContract)

                          let receiptCount = 0;
                               
                          let managerDisplayName = null;
                          let isSubscribedCurrentBool = false;

                          
                         
                            authenticatedPut('api1169ba1e', '', { 
                              headers: { Authorization: `Bearer ${cognitoID}` },
                              body: { 
                                category: 'db',
                                tableName: 'receipts', 
                                filterExpression: "contracts = :contract", 
                                requestOperation: 'get',
                                expressionAttributeValues: { 
                                  ':contract': scopedContract,
                                },
                              }
                            }).then((contractReceipts) => {
                              receiptCount = Number(contractReceipts.length)
                              authenticatedPut('api1169ba1e', '', { 
                                headers: { Authorization: `Bearer ${cognitoID}` },
                                body: { 
                                  category: 'db',
                                  tableName: 'contracts', 
                                  primaryKey: scopedContract, 
                                  requestOperation: 'get',
                                }
                              }).then((_scopedContractData) => {
                                if(_scopedContractData.hasOwnProperty('Item')){
                                  if(_scopedContractData.Item.hasOwnProperty('whitelist')){
                                    let scopedContractData = _scopedContractData.Item
                                    whitelist = scopedContractData.whitelist
                                    manager = scopedContractData.managerUsername;
                                    lookupKey = scopedContractData.lookupKey;

                                    
                                    managerDisplayName = manager
                                    that.setState({
                                      managerDisplayName
                                    }, () => {
                                      authenticatedPut('api1169ba1e', '', { 
                                        headers: { Authorization: `Bearer ${cognitoID}` },
                                        body: { 
                                            category: 'db',
                                            tableName: 'socialUserData', 
                                            primaryKey: String(manager), 
                                            requestOperation: 'get',
                                        }
                                      }).then((userData) => {
                                        if(userData.hasOwnProperty('Item')){
                                          if(userData.Item.hasOwnProperty('dynamicPublicUsername')){
                                            managerDisplayName = userData.Item.dynamicPublicUsername
                                            that.setState({
                                              managerDisplayName
                                            })
                                          }
                                        }
                                      })  
                                    })

                                    authenticatedPut('api1169ba1e', '', {
                                      headers: { Authorization: `Bearer ${cognitoID}` },
                                      body: { category: 'db', tableName: 'users', primaryKey: manager, requestOperation: 'get' },
                                    }).then((membershipData) => {
                                      if ((membershipData.Item || {}).isSubscribedCurrentBool === true) {
                                                  
                                                  isSubscribedCurrentBool = true
                                                  buildSearchResult()
                                                } else {
                                                  
                                                  isSubscribedCurrentBool = false
                                                  buildSearchResult()
                                                }
                                    });

                                    contractStructure = scopedContractData.contractStructure

                                    if(!contractStructure){
                                      contractStructure = 'creditLine'
                                    }

                                    if(scopedContractData.hasOwnProperty('offeredLenderCommissionUSD')){
                                      offeredLenderCommissionUSD = scopedContractData.offeredLenderCommissionUSD
                                    } else {
                                      offeredLenderCommissionUSD = 1
                                    }
                                    targetValue = scopedContractData.targetValue
                                    
                                    if(Number(finalRequestsSum) < Number(loanTarget)){
                                      _offeredLenderCommissionUSD_adjusted = Number(offeredLenderCommissionUSD) * (Number(finalRequestsSum)/Number(loanTarget))
                                      offeredLenderCommissionUSD_adjusted = Number(offeredLenderCommissionUSD) * (Number(finalRequestsSum)/Number(loanTarget))
                                    } else {
                                      _offeredLenderCommissionUSD_adjusted = Number(offeredLenderCommissionUSD)
                                      offeredLenderCommissionUSD_adjusted = Number(offeredLenderCommissionUSD)
                                    }
                                
                                    if(finalRequestsSum <= 1){
                                      _offeredLenderCommissionUSD_adjusted = 0
                                      offeredLenderCommissionUSD_adjusted = 0
                                    }

                                    offeredLenderCommissionUSD_adjusted = offeredLenderCommissionUSD_adjusted.toFixed(0)

                                    function buildSearchResult(){

                                        trackPageRequest(web3.eth.getBalance(scopedContract))
                                          .then((res) => { 
                                            balance = Number(res)
                                            
                                              intRate = scopedContractData.intRate;
                                              totalContributed = scopedContractData.totalContributed;

                                              intRate = parseInt(intRate, 10)
                                              totalContributed = parseInt(totalContributed, 10)/1000000000000000000
                                              lenderCt = parseInt(lenderCt, 10)

                                              balance = (Number(balance  - Number(scopedContractData.targetValue)/1.99))/1000000000000000000
                                              balance = Math.round(parseFloat(balance)*100000)/100000




                                              if(managerDisplayName && isSubscribedCurrentBool){
                                                managerDisplay = managerDisplayName
                                              } else if(corporateBackedUsernamesArray.includes(manager)){
                                                managerDisplay = 'LNDRBLCK'
                                              } 

                                              contractBoxColor = 'rgba(0, 158, 129, 0.05)'
                                              contractBoxBorderColor = 'rgba(0, 158, 129, 0.5)'

                                              if(corporateBackedUsernamesArray.includes(manager)){
                                                isCorporateBondBool = true                                                
                                              } else {
                                                isCorporateBondBool = false
                                              }

                                              if(String(balance).length > 6){
                                                balance = balance.toFixed(4)
                                              }


                                              let profilePicture_base64 = null;
                                              let profilePicture_uri = null;
                                              let bioString = null

                                              profilePicture_uri = `https://api.dicebear.com/7.x/identicon/png?size=140&seed=${manager.toLowerCase()}`;

                                              Storage.get(
                                                `${manager.toLowerCase()}/profilePicture.jpg`,
                                                {
                                                    bucket: "platform-user-media-uploads",
                                                    level: "public"
                                                }
                                              ).then((res) => {
                                                  trackPageRequest(fetch(
                                                    res
                                                  )).then((image) => {

                                                    if(image.status == 200){
                                                      profilePicture_uri = res;
                                                    }

                                                    mediaMapArrayUserMap = {}

                                                    buildMediaData();
                                                    function buildMediaData(){
                                                      authenticatedPut('api1169ba1e', '', { 
                                                        headers: { Authorization: `Bearer ${cognitoID}` },
                                                        body: { 
                                                            category: 'db',
                                                            tableName: 'socialUserData', 
                                                            primaryKey: String(manager), 
                                                            requestOperation: 'get',
                                                        }
                                                      }).then((userData) => {




                                                          if(userData.hasOwnProperty('Item')){
                                                            if(userData.Item.hasOwnProperty('bioString')){
                                                              bioString = String(userData.Item.bioString)
                                                            } else {
                                                              bioString = 'No Bio :('
                                                            }

                                                            let mediaArray = []
                                                            if(userData.Item.hasOwnProperty('mediaArray')){
                                                              mediaArray = userData.Item.mediaArray
                                                            }
                                                            
                                                            let mediaMapArray = []

                                                            loopUserMediaArray(0)
                                                            function loopUserMediaArray(m){


                                                              if(m<=mediaArray.length-1){
                                                                let thisFileName = mediaArray[m]
                                                                let caption = '...'
                                                                let uploadTimestamp = 0;
                                                                let likesArray = [];
                                                                let commentsMapArray = [];
                                                                let messageText = null;
                                                                
                                                                Storage.get(
                                                                    thisFileName,
                                                                    {
                                                                        bucket: "platform-user-media-uploads",
                                                                        level: "public"
                                                                    }
                                                                ).then((res) => {
                                                                    if(res){
                                
                                                                        authenticatedPut('api1169ba1e', '', { 
                                                                            headers: { Authorization: `Bearer ${cognitoID}` },
                                                                            body: { 
                                                                                category: 'db',
                                                                                tableName: 'mediaUploads', 
                                                                                primaryKey: String(thisFileName), 
                                                                                requestOperation: 'get',
                                                                            }
                                                                        }).then((mediaData) => {
                                                                            if(mediaData.hasOwnProperty('Item')){
                                                                                if(mediaData.Item.hasOwnProperty('caption')){
                                                                                  caption = String(mediaData.Item.caption)
                                                                                }
                                                                                if(mediaData.Item.hasOwnProperty('uploadTimestamp')){
                                                                                  uploadTimestamp = String(mediaData.Item.uploadTimestamp)
                                                                                }
                                                                                if(mediaData.Item.hasOwnProperty('likesArray')){
                                                                                  likesArray = mediaData.Item.likesArray
                                                                                }
                                                                                if(mediaData.Item.hasOwnProperty('commentsMap')){
                                                                                  commentsMap = mediaData.Item.commentsMap
                                                                                }
                                                                                if(mediaData.Item.hasOwnProperty('commentsMapArray')){
                                                                                  commentsMapArray = mediaData.Item.commentsMapArray
                                                                                }

                                                                                if(mediaData.Item.hasOwnProperty('messageText')){
                                                                                  messageText = mediaData.Item.messageText
                                                                                }
                            


                                                                                function loopCommentsArray(c){

                                                                                  if(commentsMapArray.length-1 >= c && commentsMapArray.length > 0){
                                                                                    let thisComment = commentsMapArray[c]
                                                                                    let thisSender = thisComment.sender

                                                                                    let profilePicture_uri = `https://api.dicebear.com/7.x/identicon/png?size=140&seed=${thisSender.toLowerCase()}`;
                                                
                                                                                    Storage.get(
                                                                                      `${thisSender.toLowerCase()}/profilePicture.jpg`,
                                                                                      {
                                                                                          bucket: "platform-user-media-uploads",
                                                                                          level: "public"
                                                                                      }
                                                                                    ).then((res) => {
                                                                                      trackPageRequest(fetch(
                                                                                        res
                                                                                      )).then((image) => {

                                                                                        if(image.status == 200){
                                                                                          profilePicture_uri = res;
                                                                                        }
                                                                                        commentsMapArray[c]['profilePictureURI'] = profilePicture_uri
                                                                                        commentsMapArray[c]['mediaFileName'] = thisFileName

                                                                                        let commentsReplyMapArray = []
                                                                                        
                                                                                        authenticatedPut('api1169ba1e', '', { 
                                                                                          headers: { Authorization: `Bearer ${cognitoID}` },
                                                                                          body: { 
                                                                                              category: 'db',
                                                                                              tableName: 'mediaUploadComments', 
                                                                                              primaryKey: commentsMapArray[c].messageID, 
                                                                                              requestOperation: 'get',
                                                                                          }
                                                                                        }).then((messageData) => {
                                                                                        

                                                                                          if(messageData.hasOwnProperty('Item')){

                                                                                            commentsMapArray[c]['likesArray'] = messageData.Item.likesArray

                                                                                            if(messageData.Item.hasOwnProperty('commentsReplyMapArray')){
                                                                                              commentsReplyMapArray = messageData.Item.commentsReplyMapArray
                                                                                            }
                                                                                          
                                                                                            function loopCommentsReplyArray(r){
                                                                                            
                                                                                              if(commentsReplyMapArray.length-1 >= r && commentsReplyMapArray.length > 0){
                                                                                                let thisComment = commentsReplyMapArray[r]
                                                                                                let thisSender = thisComment.sender
                        
                                                                                                let profilePicture_uri = `https://api.dicebear.com/7.x/identicon/png?size=140&seed=${thisSender.toLowerCase()}`;
                                                            
                                                                                                Storage.get(
                                                                                                  `${thisSender.toLowerCase()}/profilePicture.jpg`,
                                                                                                  {
                                                                                                      bucket: "platform-user-media-uploads",
                                                                                                      level: "public"
                                                                                                  }
                                                                                                ).then((res) => {
                                                                                                  trackPageRequest(fetch(
                                                                                                    res
                                                                                                  )).then((image) => {
                                                                                                    if(image.status == 200){
                                                                                                      profilePicture_uri = res;
                                                                                                    }
                                                                                                    commentsReplyMapArray[r]['profilePictureURI'] = profilePicture_uri
                                                                                                    commentsReplyMapArray[r]['messageReplyID'] = commentsReplyMapArray[r].messageID
                                                                                                    commentsReplyMapArray[r]['likesArray'] = commentsReplyMapArray[r].likesArray
                                                                                                    

                                                                                                    loopCommentsReplyArray(r+1)
                                                                                                  })
                                                                                                })
                                                                                              } else {
                                                                                                commentsMapArray[c]['commentsReplyMapArray'] = commentsReplyMapArray
                                                                                                loopCommentsArray(c+1)

                                                                                              }
                                                                                            }

                                                                                            loopCommentsReplyArray(0)

                                                                                          } else {
                                                                                            loopCommentsArray(c+1)
                                                                                          }
                                                                                        })
                                                                                      })
                                                                                    })

                                                                                  } else {

                                                                                    mediaMapArray.unshift({
                                                                                      mediaURI: res,
                                                                                      mediaFileName: thisFileName,
                                                                                      mediaItemCaption: caption,
                                                                                      uploadTimestamp: uploadTimestamp,
                                                                                      likesArray: likesArray,
                                                                                      commentsMapArray: commentsMapArray,
                                                                                      messageText,
                                                                                      publisherUsername: managerDisplayName,
                                                                                    })
                                    
                                                                                    mediaMapArray.sort(function(a,b) {
                                                                                        return (b.uploadTimestamp - a.uploadTimestamp)
                                                                                    });

                                                                                    loopUserMediaArray(m+1)

                                                                                  }
                                                                                }
                                                                                loopCommentsArray(0);

                                                                            }
                                                                        })
                                                                        
                                                                    }
                                                                }).catch((err)=>{
                                                                  loopUserMediaArray(m+1)
                                                                })
                                                              } else {
                                                                mediaMapArrayUserMap[manager] = mediaMapArray
                                                                that.setState({
                                                                  mediaMapArrayUserMap
                                                                })
                                                                buildContractMapArrays()
                                                              }
                                                            }
                                                          } else {
                                                            bioString = 'No Bio :('
                                                          }
                                                        })
                                                      }


                                                      function buildContractMapArrays(){

                                                        authenticatedPut('api1169ba1e', '', { 
                                                          headers: { Authorization: `Bearer ${cognitoID}` },
                                                          body: { 
                                                            category: 'db',
                                                            tableName: 'users', 
                                                            primaryKey: manager, 
                                                            requestOperation: 'get',
                                                          }
                                                        }).then((userData) => {
                                                      
                                                                let firstName = userData.Item.firstName ?? ''
                                                                let lastName = userData.Item.lastName ?? ''

                                                                let fullName = firstName.substring(0,1).toUpperCase()+firstName.substring(1,firstName.length) + ' ' + lastName.substring(0,1).toUpperCase()+lastName.substring(1,lastName.length)
                                                                
                                                                let price_usd = 1;

                                                                let _totalRepaid_nonConvert = parseFloat(userData.Item.totalPaid, 10)/1000000000000000000
                                                                let _borrowingRec_nonConvert = parseFloat(userData.Item.totalWithdrawn, 10)/1000000000000000000
                                                                let _joinDateSecs = userData.Item.joinDateSecs
                                                              
                                                                let raters = userData.Item.raters;
                                                                let ratingsMap = userData.Item.ratingsMap;
                                                                let ratingSum = 0;


                                                                for(let r=0; r<=raters.length-1; r++){
                                                                  ratingSum += ratingsMap[raters[r]].rating
                                                                }

                                                                userAvgRating = (ratingSum/raters.length).toFixed(1)
                                                                if(_borrowingRec_nonConvert == 0){
                                                                  blenderScore = 400
                                                                } else {
                                                                  blenderScore = Math.ceil( 500 * (_totalRepaid_nonConvert/_borrowingRec_nonConvert) + 400 ) 
                                                                }     
                                                                
                                                                let values = [['Date', 'Avail. Balance']]
                                                                let firstDayValueFound = false;
                                                                let firstDayValue;
                                                                let firstDayValueIndex;
                                                                let firstDayValueDelta;
                                                                let lastDayValueFound = false;
                                                                let lastDayValue;
                                                                let lastDayValueIndex;
                                                                let previousDayValue1 = 'null';
                                                                let previousDayValueIndex;
                                                                let allZeroValues = [['Date', 'Avail. Balance'],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0]]
                                                    
                                                                for(let j=0; j<=timeArray.length-1; j++){
                                                                  function iffer(i){
                                                                    if(i == timeArray.length-1){
                                                                      if(previousDayValue1 != 'null'){
                                                                        lastDayValueFound = true
                                                                        lastDayValue = previousDayValue1
                                                                        lastDayValueIndex = previousDayValueIndex
                                                                      } else {
                                                                        values = allZeroValues
                                                                      }
                                                                    }
                                                                  }
                                                                  
                                                                  if(scopedContractData.hasOwnProperty('interactions')){
                                                                    if(scopedContractData.interactions.hasOwnProperty(timeArray[j])){
                                                                      previousDayValue1 = scopedContractData.interactions[timeArray[j]].value
                                                                      previousDayValueIndex = j
                                                                      if(firstDayValueFound == false){
                                                                        firstDayValueFound = true
                                                                        firstDayValue = scopedContractData.interactions[timeArray[j]].value
                                                                        firstDayValueDelta = scopedContractData.interactions[timeArray[j]].valueDelta
                                                                        firstDayValueIndex = j

                                                                        iffer(j)
                                                                      } else {
                                                                        iffer(j)
                                                                      }
                                                                    } else {
                                                                      iffer(j)
                                                                    }
                                                                  } else {
                                                                    iffer(j)
                                                                  }
                                                                
                                                                }
                                                    
                                                                                                            

                                                                let xMax = 0;
                                                                let xMin = 0;

                                                                if(values.length <= 1){
                                                                  let previousDayValue2
                                                                  for(let b=0; b<=timeArray.length-1; b++){
                                                                    if(b < firstDayValueIndex){
                                                                      values.push(['null', Number(firstDayValue) - Number(firstDayValueDelta)])
                                                                    } else if(b == firstDayValueIndex){
                                                                      values.push(['null', Number(firstDayValue)])
                                                                      previousDayValue2 = firstDayValue
                                                                    } else if(b >= lastDayValueIndex){
                                                                      values.push(['null', Number(lastDayValue)])
                                                                    } else if(b > firstDayValueIndex && b < lastDayValueIndex){
                                                                      if(scopedContractData.interactions.hasOwnProperty(timeArray[b])){
                                                                        values.push(['null', Number(scopedContractData.interactions[timeArray[b]].value)])
                                                                        previousDayValue2 = scopedContractData.interactions[timeArray[b]].value
                                                                      } else {
                                                                        values.push(['null', Number(previousDayValue2)])
                                                                      }
                                                                    }
                                                                    if(values[values.length-1][1] > xMax){
                                                                      xMax = values[values.length-1][1];
                                                                    } else if(values[values.length-1][1] < xMin){
                                                                      xMin = values[values.length-1][1];
                                                                    }
                                                                  }
                                                                }

                                                                for(let k=0; k<=values.length-2; k++){
                                                                  if(k != 0){
                                                                    valueDeltas += Math.abs(parseInt(values[k][1], 10) - parseInt(values[k-1][1], 10))
                                                                  } else {
                                                                    valueDeltas += 0
                                                                  }
                                                                }
                                                          
                                                                valueDeltas = parseInt(valueDeltas, 10)
                                                                contributionAvg = contributionSum/contributions.length
                                                                contributionAvg = contributionAvg || 0

                                                                if(!addedContractAddress.includes(scopedContract)){
                                                                  searchedContractsArray = [{
                                                                    xMax,
                                                                    xMin,
                                                                    isSubscribedCurrentBool,
                                                                    address: scopedContract, 
                                                                    contractLookupID: lookupKey,
                                                                    activityAvg: contributionAvg, 
                                                                    deltaSum: valueDeltas, 
                                                                    blenderScore, 
                                                                    userAvgRating,
                                                                    displayName: managerDisplayName,
                                                                    fullName,
                                                                    manager, 
                                                                    intRate: intRate + ' %', 
                                                                    totalContributed, 
                                                                    balance: availableCredit, 
                                                                    values,
                                                                    lenderCt,
                                                                    receiptCount,
                                                                    contractBoxColor,
                                                                    contractBoxBorderColor,
                                                                    isCorporateBondBool,
                                                                    profilePicture_base64,
                                                                    profilePicture_uri,
                                                                    bioString,
                                                                  }]
                                                                  addedContractAddress.push(scopedContract) 
                                
                                                                      
                                                        


                                                                  clearTimeout(searchTimer);
                                                                  that.setState({ 
                                                                    searchedContractsArray,
                                                                    searchLookupFailed: false,
                                                                    searchActivityBool: false
                                                                  })

                                                                }         




                                                        })

                                                    }
                                                  })
                                              })
                                        })
                                      }
                                  }     
                                }
                              })
                            })
                          

                      })


                })
              
              } else {
                searchedContractsLooper--
                if(searchedContractsLooper == 0){
                  that.setState({ 
                    searchResultContracts: searchContent,
                    searchActivityBool: false,
                  })
                }
              }
            }  
          } else {
            clearTimeout(searchTimer);
            that.setState({ 
              searchResultContracts: [],
              searchedContractsArray: [],
              searchActivityBool: false,
            })
          }
        })
      }).catch((error) => {
        clearTimeout(searchTimer);
        console.error('Browse search lookup failed:', error?.message || error);
        that.setState({searchedContractsArray: [], searchResultContracts: [], searchActivityBool: false, searchLookupFailed: true});
      })

  };

  

  checkLenderblockSubscriberStatus(){
          
    trackPageRequest(Auth.currentAuthenticatedUser()).then((res) => {
      currentUser = res.username

      authenticatedPut('api1169ba1e', '', { 
        headers: { Authorization: `Bearer ${cognitoID}` },
        body: { 
          category: 'db',
          tableName: 'users', 
          primaryKey: String(currentUser), 
          requestOperation: 'get',
        }
      }).then((userData) => {
      let primaryDisplayCurrency = userData.Item.preferences.primaryDisplayCurrency
      let secondaryDisplayCurrency = userData.Item.preferences.secondaryDisplayCurrency
      let publicKey = userData.Item.publicKey
      let emailAddress = userData.Item.emailAddress
      let firstName = userData.Item.firstName
      let firstNameFormatted = firstName.substr(0,1).concat(firstName.substr(1,firstName.length-1))


      
      

      

      that.setState({
          
      })
      



        
        let headers = new Headers();

        Promise.resolve().then(() => {
if (userData.Item.isSubscribedCurrentBool === true) {
                    
                    isSubscribedCurrentBool = true
                    that.setState({
                        isSubscribedCurrentBool,
                        transferCommissionPercentDecimal: 0
                    })
                    
                  } else {
                    
                    isSubscribedCurrentBool = false
                    that.setState({
                        isSubscribedCurrentBool,
                        transferCommissionPercentDecimal: 0
                    })
                    
                  }
});

      })
    })


  }

  withdrawEther(){
    // Legacy bank/card payment path replaced by the shared CryptoMoneyPanel.
    return;
  }

  
 
  sendTransferFinal(){


    that.setState({
      pendingTransactionLoaderOverlay: true,
    })

    let weiTransferValue = parseInt(Number(that.state.moneyTransactionLiveValue)*1000000000000000000, 10)
    let transferValueUSD = Number(that.state.moneyTransactionLiveValue);

    let destinationUsername = String(that.state.destinationUsername).split(" ").join("")
    let destinationAddress;
    let recipientUser;
    let randomString1 = String(Date.now()) + Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
    let randomString2 = String(Date.now()) + Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
    randomString1 =  randomString1.substring(0,18)
    randomString2 =  randomString2.substring(0,18)

    that.setState({
        showPageLoader: true,
        showPasswordOverlay: false,
        password: String(that.state.passwordText).replace(/\s/g, '')
    })

    if(that.state.destinationUsername != null){

            recipientUser = destinationUsername.toLowerCase()
            that.setState({
              recipientUser
            })

            authenticatedPut('api1169ba1e', '', { 
                headers: { Authorization: `Bearer ${cognitoID}` },
                body: { 
                category: 'db',
                tableName: 'users', 
                primaryKey: recipientUser.toLowerCase(), 
                requestOperation: 'get',
                }
            }).then((recipient) => {
              if(recipient.hasOwnProperty('Item')){
                  destinationAddress = recipient.Item.publicKey
              

                  let recipientFirstName = recipient.Item.firstName
                  let recipientEmailAddress = recipient.Item.emailAddress


                  authenticatedPut('api1169ba1e', '', { 
                      headers: { Authorization: `Bearer ${cognitoID}` },
                      body: { 
                        category: 'db',
                        tableName: 'users', 
                        primaryKey: currentUser, 
                        requestOperation: 'get',
                      }
                  }).then(async (response) => {

                      let publicKey = response.Item.publicKey
                      let emailAddress = response.Item.emailAddress
                      let firstName = response.Item.firstName
                      let privateKey = response.Item.privateKey


                      let bytes = CryptoJS.AES.decrypt(String(privateKey), that.state.passwordText);


                      var plaintextPK

                      // Recipient amount + Blender commission equals the entered total.
                      // The commission is not charged twice; reserve gas for both transactions.
                      const transferNetworkFeeWei = ethers.BigNumber.from('200000').mul('1200000000').mul(2);
                      let confirmedBalanceWei;
                      try {
                        const liveBalance = await highRateWeb3.eth.getBalance(publicKey);
                        confirmedBalanceWei = ethers.BigNumber.from(String(liveBalance));
                      } catch (balanceError) {
                        that.setState({
                          errorTags: <p style={{ textAlign: 'left' }}>
                            {that.state.selectedLanguage == 'spanish'
                              ? 'No se pudo verificar el saldo de tu Cartera Blender. Inténtalo de nuevo.'
                              : 'Could Not Verify Your Blender Wallet Balance. Please Try Again.'}
                          </p>,
                          showInsufficientFundsOverlay: false,
                          showConfirmationOverlay: false,
                          pendingTransactionLoaderOverlay: false,
                          showPageLoader: false,
                          disableWhileTxn: false,
                        });
                        return;
                      }
                      const transferSpendableWei = confirmedBalanceWei.gt(transferNetworkFeeWei)
                        ? confirmedBalanceWei.sub(transferNetworkFeeWei) : ethers.constants.Zero;
                      const transferAmountWei = ethers.utils.parseEther(String(that.state.moneyTransactionLiveValue).trim());

                      if(transferAmountWei.gt(0) && transferAmountWei.lte(transferSpendableWei)){
                        try{
                          plaintextPK = bytes.toString(CryptoJS.enc.Utf8);
                          finishTxn()
                        } catch(err){
                          
                          
                          that.setState({
                            errorTags: 
                              <p style={{ textAlign: 'left', }}>
                                {that.state.selectedLanguage == 'spanish' ? 
                                  'Contraseña no Válida'
                                    :
                                  'Incorrect Password'
                                }
                              </p>,
                              showInsufficientFundsOverlay: false,
                              showConfirmationOverlay: false,
                              pendingTransactionLoaderOverlay: false,
                              showPageLoader: false,
                              password: null,
                              actionValue: null,
                              disableWhileTxn: false,
                          })
                        }
                      } else {
                        
                        that.setState({
                          errorTags: 
                            <p style={{ textAlign: 'left', }}>
                              {that.state.selectedLanguage == 'spanish' ? 
                                `El valor máximo de transferir desde tu cartera Blender es ${(Math.floor(Number(ethers.utils.formatEther(transferSpendableWei)) * 100) / 100).toFixed(2)} USD`
                                  :
                                `The maximum transfer value from your Blender Wallet is ${(Math.floor(Number(ethers.utils.formatEther(transferSpendableWei)) * 100) / 100).toFixed(2)} USD`
                              }
                            </p>,
                            showInsufficientFundsOverlay: false,
                            showConfirmationOverlay: false,
                            pendingTransactionLoaderOverlay: false,
                            showPageLoader: false,
                            password: null,
                            actionValue: null,
                            disableWhileTxn: false,
                        })
                      }

                      function finishTxn(){

                          plaintextPK = plaintextPK.substring(64, plaintextPK.length-64) 


                          let mnemonicWallet = ethers.Wallet.fromMnemonic(plaintextPK);
                          var plaintextMnemonic = mnemonicWallet.privateKey

                          highRateWeb3.eth.getTransactionCount(publicKey).then((_nonce) => {
                          
                            const nonce = _nonce;

                            const tx_sendTransfer = { 
                              chainId: 100,
                              gas: '200000',
                              gasPrice: String(1200000000),
                              from: publicKey, 
                              to: destinationAddress, 
                              value: (Number(weiTransferValue)*(1-that.state.transferCommissionPercentDecimal)).toLocaleString('fullwide', {useGrouping: false}),
                              data: "",
                              nonce: nonce
                            }
  
                            const tx_sendTransfer_commission = { 
                              chainId: 100,
                              gas: '200000',
                              gasPrice: String(1200000000),
                              from: publicKey, 
                              to: blenderCommissionPublicKey, 
                              value: (Number(weiTransferValue)*that.state.transferCommissionPercentDecimal).toLocaleString('fullwide', {useGrouping: false}),
                              data: "",
                              nonce: nonce+1
                            }

                            var tx_sendTransfer_receipt;

                            highRateWeb3.eth.accounts.signTransaction(tx_sendTransfer_commission, plaintextMnemonic)
                              .then((signedTx_sendTransferCommission) => {
                                
                                highRateWeb3.eth.accounts.signTransaction(tx_sendTransfer, plaintextMnemonic)
                                  .then((signedTx_sendTransfer) => {

                                    highRateWeb3.eth.sendSignedTransaction(signedTx_sendTransfer.rawTransaction).then((_tx_sendTransfer_receipt) => {
                                      tx_sendTransfer_receipt = _tx_sendTransfer_receipt.transactionHash
                                    }).then((res) => {

                                      highRateWeb3.eth.sendSignedTransaction(signedTx_sendTransferCommission.rawTransaction).then((receipt) => {

                                        if(that.state.selectedLanguage == 'spanish'){
                                          if(that.state.isSubscribedCurrentBool){
                                            that.setNativeNotification(`Blender Pro Plus Ahorros - Has guardado ${Number(Number(transferValueUSD)*0.05).toFixed(2)} USD por transferir a ${String(recipientUser).toUpperCase()}!`)
                                          } else {
                                            that.setNativeNotification(`Transferiste ${Number(transferValueUSD).toFixed(2)} USD a ${String(recipientUser).toUpperCase()}!`)
                                          }
                                        } else {
                                          if(that.state.isSubscribedCurrentBool){
                                            that.setNativeNotification(`Blender Pro Plus Savings - You saved ${Number(Number(transferValueUSD)*0.05).toFixed(2)} USD transferring to ${String(recipientUser).toUpperCase()}!`)
                                          } else {
                                            that.setNativeNotification(`You transferred ${Number(transferValueUSD).toFixed(2)} USD to ${String(recipientUser).toUpperCase()}!`)
                                          }
                                        }


                                        authenticatedPut('api1169ba1e', '', { 
                                          headers: { Authorization: `Bearer ${cognitoID}` },
                                          body: { 
                                              category: 'db',
                                              tableName: 'pendingTransactions', 
                                              primaryKey: tx_sendTransfer_receipt, 
                                              requestOperation: 'update',
                                              updateExpression: 
                                              `SET 
                                                  transactionType = :txnType,
                                                  creationDate = :creationDate, 
                                                  creationDateSecs = :creationDateSecs, 
                                                  #st = :status, 
                                                  currentUser = :currentUser,
                                                  publicKey = :publicKey,
                                                  emailType = :emailType,
                                                  firstName = :firstName,
                                                  emailAddress = :emailAddress,
                                                  adjustedWeiValueNum = :adjustedWeiValueNum,
                                                  recipientUser = :recipientUser,
                                                  recipient = :recipient,
                                                  recipientEmailAddress = :recipientEmailAddress,
                                                  recipientFirstName = :recipientFirstName,
                                                  randomString1 = :randomString1,
                                                  randomString2 = :randomString2,
                                                  application = :application,
                                                  currency = :currency,
                                                  conversionRateGlobal = :conversionRateGlobal
                                              `,
                                              expressionAttributeNames: {"#st":"status"},
                                              expressionAttributeValues: { 
                                                  ':txnType': 'transfer',
                                                  ':creationDate': new Date(),
                                                  ':creationDateSecs': Date.now(), 
                                                  ':currentUser': currentUser,
                                                  ':status': 'active',
                                                  ':publicKey': publicKey,
                                                  ':emailAddress': emailAddress,
                                                  ':emailType': 'contribution',
                                                  ':firstName': firstName,
                                                  ':adjustedWeiValueNum': Number(weiTransferValue) * (-1),
                                                  ':recipientUser': recipientUser,
                                                  ':recipient': destinationAddress,
                                                  ':randomString1': randomString1,
                                                  ':randomString2': randomString2,
                                                  ':recipientEmailAddress': recipientEmailAddress,
                                                  ':recipientFirstName': recipientFirstName,
                                                  ':application': 'TBP',
                                                  ':currency': 'USD',
                                                  ':conversionRateGlobal': 1
                                              }
                                          }
                                          }).then((res) => {

                                              authenticatedPut('api1169ba1e', '', { 
                                                headers: { Authorization: `Bearer ${cognitoID}` },
                                                body: { 
                                                    category: 'db',
                                                    tableName: 'general', 
                                                    primaryKey: 'txnHash', 
                                                    requestOperation: 'update',
                                                    updateExpression: `SET txnHash = list_append(txnHash, :txnHash)`, 
                                                    expressionAttributeValues: { 
                                                      ':txnHash': [tx_sendTransfer_receipt]
                                                    }
                                                }
                                              }).then((res) => {

                                                if(that.state.isSubscribedCurrentBool){
                                                  that.setState({
                                                    successSubscriberSavingsOverlay: true,
                                                    pendingTransactionLoaderOverlay: false,
                                                  })
                                                } else {
                                                  that.setState({
                                                    pendingTransactionLoaderOverlay: false,
                                                    successfulTransferOverlay: true,
                                                    pendingTransactionLoaderOverlay: false,
                                                  })
                                                }

                                                that.setState({
                                                    showInsufficientFundsOverlay: false,
                                                    showConfirmationOverlay: false,
                                                    showPasswordOverlay: false,
                                                    showPageLoader: false,
                                                    password: null,
                                                    actionValue: null,
                                                    disableWhileTxn: false,
                                                })
                                                setTimeout(() => {
                                                  that.setState({
                                                    successfulTransferOverlay: false,
                                                    successSubscriberSavingsOverlay: false,
                                                  })
                                                }, 3000)
                                          })
                                      })




                                      }).catch((err) => {
                                      })
                                    }).catch((err) => {
                                    });

                                }).catch((err) => {
                                })
                              }).catch((err) => {
                              });
                          })

                          plaintextPK = null
                          privateKey = null

                      }
                  })
              } else{
                
                that.setState({
                  errorTags: 
                    <p
                      style={{
                        textAlign: 'left',
                      }}
                    >
                      {that.state.selectedLanguage == 'spanish' ? 
                        'Recipiente no Válida'
                          :
                        'Invalid Recipient'
                      }
                    </p>,
                  showPasswordOverlay: false,
                  pendingTransactionLoaderOverlay: false,
                })
              }
          })


    }
  }

  updateContents(){

    creditLineArray.sort(function(a,b) {
      return (b.balance - a.balance)
    })

    recentlyViewedContractsArray.sort(function(a,b) {
      let bIndex = recentlyViewedContracts.indexOf(b.address)
      let aIndex = recentlyViewedContracts.indexOf(a.address)
      return (bIndex - aIndex)
    })

    let iconComp;
    iconComp = that.state.primaryDisplayCurrency 

    that.setState({
      creditLineArray: [],
      creditLineAddressArray: [],
      wishlistArray: [],
      recentlyViewedContractsArray: [],
    }, () => {


      that.setState({
        allBorrowerUsernamesDisplayNames,
        activeSearchBorrowerAccountBool: false,
        activeSearchTransferBool: false,
        loanAgreementArray,
        topMoversArray,
        creditLineArray,
        creditLineAddressArray,
        wishlistArray,
        recentlyViewedContractsArray,
        trigger: 'on',
        showOverlay: false,
        iconComp,
        refreshingIconBool: false
      })

    })
           

  }


  componentDidCatch(error){
  }


  componentDidMount(){
    

    if (cachedHomeState) {
      this.setState({
    ...cachedHomeState,
    navigationDestinationObject: {
        navigationRoute: '',
    },
});
      return;
    }

    if(isMobile){
      // window.open("https://lenderblockcorp.com/blenderplatform","_self")
    }
  
      

      allBorrowerUsernamesDisplayNames = [];

      that.setState({
        selectedLanguage: localStorage.getItem('primaryLanguage'),
        mode_light_dark: localStorage.getItem('mode_light_dark'),
        errorTags: null,
        pendingTransactionLoaderOverlay: false,
        navigationOverlay: false,
        transferCommissionPercentDecimal: 0.05,
        showSearchDropDownMenuBool: false,
        allBorrowerUsernamesDisplayNames: [],
        moneyTransferOverlay: false,
      })

      that.buildData(1)

      if(routeProps && routeProps.prompt == 'welcome'){
        that.setState({
          welcomeOverlay: true
        })
      }

      trackPageRequest(Auth.currentAuthenticatedUser()).then((res) => {
        currentUser = res.username
        cognitoID = res.signInUserSession.idToken.jwtToken

  
        that.setState({
          currentUser
        })
      


        let allUserUsernamesDisplayNames = localStorage.getItem('allUserUsernamesDisplayNames')
        if(!allUserUsernamesDisplayNames){
          authenticatedPut('api1169ba1e', '', { 
            headers: { Authorization: `Bearer ${cognitoID}` },
            body: { 
              category: 'db',
              tableName: 'general', 
              primaryKey: 'userArray', 
              requestOperation: 'get',
            }
          }).then((_userArray) => {
            let userArray = _userArray.Item.userArray;
            let allUserUsernamesDisplayNames = []
            function loopAllUsers(u){
              if(u<=userArray.length-1){

                let thisUser = userArray[u];

                allUserUsernamesDisplayNames.push(
                  {
                    id: allUserUsernamesDisplayNames.length,
                    name: thisUser
                  }
                )
                loopAllUsers(u+1)

              } else {
                that.setState({
                  allUserUsernamesDisplayNames
                }, () => {
                  localStorage.setItem('allUserUsernamesDisplayNames', JSON.stringify(allUserUsernamesDisplayNames))
                })
              }
            }
            loopAllUsers(0)
          })
        } else {
          that.setState({
            allUserUsernamesDisplayNames: JSON.parse(allUserUsernamesDisplayNames)
          })
        }





      
          














        let profilePicture_uri = `https://api.dicebear.com/7.x/identicon/png?size=140&seed=${currentUser.toLowerCase()}`;

        that.setState({
          currentUserProfilePicture: profilePicture_uri
        })

        Storage.get(
          `${currentUser.toLowerCase()}/profilePicture.jpg`,
          {
              bucket: "platform-user-media-uploads",
              level: "public"
          }
        ).then((res) => {
          trackPageRequest(fetch(
            res
          )).then((image) => {
            if(image.status == 200){
              profilePicture_uri = res;
            }
            that.setState({
              currentUserProfilePicture: profilePicture_uri
            })
          })
        })

        authenticatedPut('api1169ba1e', '', { 
          headers: { 
            'Authorization': `Bearer ${cognitoID}`,
          },
          body: { 
            category: 'db',
            tableName: 'platformConfigurations', 
            primaryKey: 'BlenderProPlusBenefits', 
            requestOperation: 'get',
          }
        }).then((userData) => {
            let subscriberBenefitsArray = userData.Item.BlenderProPlusBenefits
            that.setState({
                subscriberBenefitsArray
            })
        })




        authenticatedPut('api1169ba1e', '', { 
          headers: { Authorization: `Bearer ${cognitoID}` },
          body: { 
            category: 'db',
            tableName: 'users', 
            primaryKey: String(currentUser), 
            requestOperation: 'get',
          }
        }).then((userData) => {
          primaryDisplayCurrency = userData.Item.preferences.primaryDisplayCurrency
          secondaryDisplayCurrency = userData.Item.preferences.secondaryDisplayCurrency
          publicKey = userData.Item.publicKey

          if(web3.utils.isAddress(publicKey)){

            

            trackPageRequest(web3.eth.getBalance(publicKey)).then((balance) => {

              walletBalanceWei = Math.max(
                0,
                Number(balance) - (2000000 * 4000000000)
              )

              that.setState({
                walletBalanceUSD: walletBalanceWei / 1000000000000000000,
                walletBalanceWei: walletBalanceWei,
                maxWalletWithdrawalWei: walletBalanceWei,
                publicKey: publicKey,
              })


            }).catch((err) => {

              

            })

          } else {

            

          }

          let firstName = userData.Item.firstName
          let lastName = userData.Item.lastName
          let phoneNumber = userData.Item.phone
          let fullName = firstName.substr(0,1).toUpperCase().concat(firstName.substring(1,firstName.length)).concat(' ').concat(lastName.substr(0,1).toUpperCase()).concat(lastName.substring(1,firstName.length))
          
          let sharePromoString = 
fullName + ` invites you to The Blender Platform:

Welcome to The Blender Platform, the global blockchain-powered credit network. 

Sign Up and Create a Credit Line to become a Borrower!  Choose your own interest rate, minimum monthly payment and credit limit.

Apply for Blender Borrower Assistance by becoming Blender Verified and requesting Collateral Assistance within your new credit-line, for assisted cost-free credit-limit increases. 

Be a Lender!  Lend to borrowers' credit lines and receive interest compounding payments.

The Blender Platform
Lend and Borrow, just like a bank!

https://lenderblockcorp.com/download
`


          that.setState({
            sharePromoString
          })

          authenticatedPut('api1169ba1e', '', { 
            headers: { Authorization: `Bearer ${cognitoID}` },
            body: { 
              category: 'db',
              tableName: 'platformConfigurations', 
              primaryKey: 'corporateBackedUsernamesArray', 
              requestOperation: 'get',
            }
          }).then((_corporateBackedUsernamesArray) => {
            corporateBackedUsernamesArray = _corporateBackedUsernamesArray.Item.corporateBackedUsernamesArray
          })

          authenticatedPut('api1169ba1e', '', { 
            headers: { Authorization: `Bearer ${cognitoID}` },
            body: { 
              category: 'db',
              tableName: 'platformConfigurations', 
              primaryKey: 'userAnnouncementMessages', 
              requestOperation: 'get',
            }
          }).then((userData) => {

              let userAnnouncementMessageArray = userData.Item.userAnnouncementMessages
              that.setState({
                  userAnnouncementMessageArray
              })

              // that.scrollHeader(userAnnouncementMessageArray.length)
          })

          that.setState({
            primaryDisplayCurrency,
            secondaryDisplayCurrency,
            // sharePromoCodeOverlay: !verifyOverlayShownBool,
            showSubscriptionPromoterOverlay: !verifyOverlayShownBool,
            refreshingIconBool: false,
            likedMediaItemMap: {},
            inviteOverlay: false,
          })


        })
        
      }).catch((err) => {

        

        trackPageRequest(Auth.signOut())

        that.setState({
          navigationDestinationObject: {
              navigationRoute: '/welcome',
          },
        })

      })
  }

  chargeUserLinked(){
    // Legacy bank/card payment path replaced by the shared CryptoMoneyPanel.
    return;
  }
  
  

  buildData(conversionRate){

    trackPageRequest(Auth.currentAuthenticatedUser()).then((res) => {
      currentUser = res.username
      cognitoID = res.signInUserSession.idToken.jwtToken
      currentUserCap = currentUser.toUpperCase()
      that.setState({ 
        currentUser,
        searchActivityBool: false,
        verifyIDOverlay: false,
        commentReplyID: null,
        commentInitMediaFileName: null,
        commentIsWritingMediaFileName: null,
        newCommentStringInput: null,
     })


      authenticatedPut('api1169ba1e', '', { 
        headers: { Authorization: `Bearer ${cognitoID}` },
        body: { 
          category: 'db',
          tableName: 'general', 
          primaryKey: 'contractArray', 
          requestOperation: 'get',
        }
      }).then((retrievedContractsArray) => {
        let all_contracts = retrievedContractsArray.Item.contractArray;

        authenticatedPut('api1169ba1e', '', { 
          headers: { Authorization: `Bearer ${cognitoID}` },
          body: { 
            category: 'db',
            tableName: 'users', 
            primaryKey: String(currentUser), 
            requestOperation: 'get',
          }
        }).then((userData) => {
          

          userWishlist = userData.Item.wishlist
          privateKey = userData.Item.privateKey
          
          recentlyViewedContracts = userData.Item.recentlyViewedContractsArray
         
          let currentDay = parseInt(Date.now()/86400000)
          let timeArray = []
          creditLineArray = [];
          creditLineAddressArray = [];
          wishlistArray = [];
          preSortedContractsArray = [];
          topMoversArray = [];
          loanAgreementArray = [];
          recentlyViewedContractsArray = []
      
          for(let t=currentDay; t>=currentDay-chartDayRange; t--){
            timeArray.unshift(t)
          }

          if(!recentlyViewedContracts){
            recentlyViewedContracts = []
          } 

          let foundRecentList = []
          for(let m=recentlyViewedContracts.length-1; m>=0; m--){
            let thisRecentContract = recentlyViewedContracts[m]
            if(!foundRecentList.includes(thisRecentContract)){
              foundRecentList.unshift(thisRecentContract)
            }
            if(m == 0){
              recentlyViewedContracts = foundRecentList;
            }
          }

          allContractsLooper = all_contracts.length;
          addedContracts = []


            for(let i=all_contracts.length-1; i>=0; i--){
              let contractBoxColor, contractBoxBorderColor, contractTextColor1, contractTextColor2;
              let contributions = [], contributionAvg, isCorporateBondBool, contributionSum, valueDeltas = 0, walletUser, blenderScore = 0, userAvgRating, targetValue, manager, lookupKey, contractStructure, offeredLenderCommissionUSD, managerDisplay, intRate, totalContributed, balance, lenderCt, whitelist, availableCredit; 
              let scopedContract = all_contracts[i];
              let scopedContractLength = scopedContract.length
              let addedListCheck = addedContracts.includes(scopedContract)
              let _i = i;

              let isSubscribedCurrentBool = false;

              if(
                scopedContract != "0x0000000000000000000000000000000000000000" &&
                addedListCheck == false &&
                scopedContractLength == 42
              ){
          



                let campaign = new web3.eth.Contract( 
                  CampaignContract_latest.abi,
                  scopedContract
                );

                campaign.methods.getSummary1().call()
                  .then(async (res) => {
                    
                    let web3BalancePost = String(res[0])
                    let loanTarget = String(res[1])
                    let finalRequestsSum = String(res[4])
                    let repaymentSum = String(res[5])
                    let insuranceTotal = res[12]

                    lenderCt = Number(res[7])

                      

                    availableCredit = await readOnChainAvailableCredit(campaign)
                    addedContracts.push(scopedContract)

                    let receiptCount = 0;
                    authenticatedPut('api1169ba1e', '', { 
                      headers: { Authorization: `Bearer ${cognitoID}` },
                      body: { 
                        category: 'db',
                        tableName: 'receipts', 
                        filterExpression: "contracts = :contract", 
                        requestOperation: 'get',
                        expressionAttributeValues: { 
                          ':contract': scopedContract,
                        },
                      }
                    }).then((contractReceipts) => {
                      receiptCount = Number(contractReceipts.length)
                      authenticatedPut('api1169ba1e', '', { 
                        headers: { Authorization: `Bearer ${cognitoID}` },
                        body: { 
                          category: 'db',
                          tableName: 'contracts', 
                          primaryKey: scopedContract, 
                          requestOperation: 'get',
                        }
                      }).then((_scopedContractData) => {
                        if(_scopedContractData.hasOwnProperty('Item')){
                          if(_scopedContractData.Item.hasOwnProperty('whitelist')){
                            let scopedContractData = _scopedContractData.Item
                            let whitelist = scopedContractData.whitelist
                            manager = scopedContractData.managerUsername;
                            lookupKey = scopedContractData.lookupKey;

                            authenticatedPut('api1169ba1e', '', { 
                              headers: { Authorization: `Bearer ${cognitoID}` },
                              body: { 
                                category: 'db',
                                tableName: 'users', 
                                primaryKey: manager, 
                                requestOperation: 'get',
                              }
                            }).then((userData) => {
                          
                              
                              Promise.resolve().then(() => {
if (userData.Item.isSubscribedCurrentBool === true) {
                                            
                                            isSubscribedCurrentBool = true
                                            buildThisCreditLine()
                                          } else {
                                            
                                            isSubscribedCurrentBool = false
                                            buildThisCreditLine()
                                          }
});
                            })

                            contractStructure = scopedContractData.contractStructure

                            if(!contractStructure){
                              contractStructure = 'creditLine'
                            }

                            if(scopedContractData.hasOwnProperty('offeredLenderCommissionUSD')){
                              offeredLenderCommissionUSD = scopedContractData.offeredLenderCommissionUSD
                            } else {
                              offeredLenderCommissionUSD = 1
                            }
                            targetValue = scopedContractData.targetValue
                            

                            function buildThisCreditLine(){
                              trackPageRequest(web3.eth.getBalance(scopedContract))
                                .then((res) => { 
                                  balance = Number(res)
                                  
                                    intRate = scopedContractData.intRate;
                                    totalContributed = scopedContractData.totalContributed;

                                    intRate = parseInt(intRate, 10)
                                    totalContributed = parseInt(totalContributed, 10)/1000000000000000000
                                    lenderCt = parseInt(lenderCt, 10)

                                    balance = (Number(balance  - Number(scopedContractData.targetValue)/1.99))/1000000000000000000
                                    balance = Math.round(parseFloat(balance * conversionRate)*100000)/100000

                                    let managerDisplayName = manager;


                                    that.setState({
                                      managerDisplayName: manager
                                    }, () => {
                                      authenticatedPut('api1169ba1e', '', { 
                                        headers: { Authorization: `Bearer ${cognitoID}` },
                                        body: { 
                                            category: 'db',
                                            tableName: 'socialUserData', 
                                            primaryKey: String(manager), 
                                            requestOperation: 'get',
                                        }
                                      }).then((userData) => {
                                        if(userData.hasOwnProperty('Item')){
                                          if(userData.Item.hasOwnProperty('dynamicPublicUsername')){
                                            managerDisplayName = userData.Item.dynamicPublicUsername
                                            that.setState({
                                              managerDisplayName 
                                            })
                                          }
                                        }


                                          contractBoxColor = 'rgba(0, 158, 129, 0.05)'
                                          contractBoxBorderColor = 'rgba(0, 158, 129, 0.5)'

                                          if(corporateBackedUsernamesArray.includes(manager)){
                                            isCorporateBondBool = true                                        
                                          } else {
                                            isCorporateBondBool = false
                                          }

                                          if(String(balance).length > 6){
                                            balance = balance.toFixed(4)
                                          }


                                          let profilePicture_base64 = null;
                                          let profilePicture_uri = null;
                                          let bioString = null

                                          profilePicture_uri = `https://api.dicebear.com/7.x/identicon/png?size=140&seed=${manager.toLowerCase()}`;

                                          Storage.get(
                                            `${manager.toLowerCase()}/profilePicture.jpg`,
                                            {
                                                bucket: "platform-user-media-uploads",
                                                level: "public"
                                            }
                                          ).then((res) => {
                                            
                                              trackPageRequest(fetch(
                                                res
                                              )).then((image) => {

                                                if(image.status == 200){
                                                  profilePicture_uri = res;
                                                }

                                                mediaMapArrayUserMap = {}

                                                buildMediaData();
                                                function buildMediaData(){
                                                  authenticatedPut('api1169ba1e', '', { 
                                                    headers: { Authorization: `Bearer ${cognitoID}` },
                                                    body: { 
                                                        category: 'db',
                                                        tableName: 'socialUserData', 
                                                        primaryKey: String(manager), 
                                                        requestOperation: 'get',
                                                    }
                                                  }).then((userData) => {




                                                      if(userData.hasOwnProperty('Item')){
                                                        if(userData.Item.hasOwnProperty('bioString')){
                                                          bioString = String(userData.Item.bioString)
                                                        } else {
                                                          bioString = 'No Bio :('
                                                        }

                                                        let mediaArray = []
                                                        if(userData.Item.hasOwnProperty('mediaArray')){
                                                          mediaArray = userData.Item.mediaArray
                                                        }
                                                        
                                                        let mediaMapArray = []

                                                        loopUserMediaArray(0)
                                                        function loopUserMediaArray(m){

                                                          if(m<=mediaArray.length-1){
                                                            let thisFileName = mediaArray[m]
                                                            let caption = '...'
                                                            let uploadTimestamp = 0;
                                                            let likesArray = [];
                                                            let commentsMapArray = [];
                                                            

                                                            Storage.get(
                                                                thisFileName,
                                                                {
                                                                    bucket: "platform-user-media-uploads",
                                                                    level: "public"
                                                                }
                                                            ).then((res) => {
                                                                if(res){
                            
                                                                    authenticatedPut('api1169ba1e', '', { 
                                                                        headers: { Authorization: `Bearer ${cognitoID}` },
                                                                        body: { 
                                                                            category: 'db',
                                                                            tableName: 'mediaUploads', 
                                                                            primaryKey: String(thisFileName), 
                                                                            requestOperation: 'get',
                                                                        }
                                                                    }).then((mediaData) => {
                                                                        if(mediaData.hasOwnProperty('Item')){

                                                                            if(mediaData.Item.hasOwnProperty('caption')){
                                                                              caption = String(mediaData.Item.caption)
                                                                            }
                                                                            if(mediaData.Item.hasOwnProperty('uploadTimestamp')){
                                                                              uploadTimestamp = String(mediaData.Item.uploadTimestamp)
                                                                            }
                                                                            if(mediaData.Item.hasOwnProperty('likesArray')){
                                                                              likesArray = mediaData.Item.likesArray
                                                                            }
                                                                            if(mediaData.Item.hasOwnProperty('commentsMapArray')){
                                                                              commentsMapArray = mediaData.Item.commentsMapArray
                                                                            }
                      


                                                                            function loopCommentsArray(c){

                                                                              if(commentsMapArray.length-1 >= c && commentsMapArray.length > 0){
                                                                                let thisComment = commentsMapArray[c]
                                                                                let thisSender = thisComment.sender

                                                                                let profilePicture_uri = `https://api.dicebear.com/7.x/identicon/png?size=140&seed=${thisSender.toLowerCase()}`;
                                            

                                                                                Storage.get(
                                                                                  `${thisSender.toLowerCase()}/profilePicture.jpg`,
                                                                                  {
                                                                                      bucket: "platform-user-media-uploads",
                                                                                      level: "public"
                                                                                  }
                                                                                ).then((res) => {
                                                                                  trackPageRequest(fetch(
                                                                                    res
                                                                                  )).then((image) => {

                                                                                    if(image.status == 200){
                                                                                      profilePicture_uri = res;
                                                                                    }
                                                                                    commentsMapArray[c]['profilePictureURI'] = profilePicture_uri
                                                                                    commentsMapArray[c]['mediaFileName'] = thisFileName

                                                                                    let commentsReplyMapArray = []
                                                                                    
                                                                                    authenticatedPut('api1169ba1e', '', { 
                                                                                      headers: { Authorization: `Bearer ${cognitoID}` },
                                                                                      body: { 
                                                                                          category: 'db',
                                                                                          tableName: 'mediaUploadComments', 
                                                                                          primaryKey: commentsMapArray[c].messageID, 
                                                                                          requestOperation: 'get',
                                                                                      }
                                                                                    }).then((messageData) => {

                                                                                      if(messageData.hasOwnProperty('Item')){

                                                                                        commentsMapArray[c]['likesArray'] = messageData.Item.likesArray

                                                                                        if(messageData.Item.hasOwnProperty('commentsReplyMapArray')){
                                                                                          commentsReplyMapArray = messageData.Item.commentsReplyMapArray

                                                                                        }
                                                                                      
                                                                                        function loopCommentsReplyArray(r){
                    
                                                                                          if(commentsReplyMapArray.length-1 >= r && commentsReplyMapArray.length > 0){
                                                                                            let thisComment = commentsReplyMapArray[r]
                                                                                            let thisSender = thisComment.sender
                    
                                                                                            let profilePicture_uri = `https://api.dicebear.com/7.x/identicon/png?size=140&seed=${thisSender.toLowerCase()}`;
                                                        
                                                                                            Storage.get(
                                                                                              `${thisSender.toLowerCase()}/profilePicture.jpg`,
                                                                                              {
                                                                                                  bucket: "platform-user-media-uploads",
                                                                                                  level: "public"
                                                                                              }
                                                                                            ).then((res) => {
                                                                                              trackPageRequest(fetch(
                                                                                                res
                                                                                              )).then((image) => {
                                                                                                if(image.status == 200){
                                                                                                  profilePicture_uri = res;
                                                                                                }
                                                                                                commentsReplyMapArray[r]['profilePictureURI'] = profilePicture_uri
                                                                                                commentsReplyMapArray[r]['messageReplyID'] = commentsReplyMapArray[r].messageID
                                                                                                commentsReplyMapArray[r]['likesArray'] = commentsReplyMapArray[r].likesArray
                                                                                                
                                                                                                loopCommentsReplyArray(r+1)
                                                                                              })
                                                                                            })
                                                                                          } else {
                                                                                            commentsMapArray[c]['commentsReplyMapArray'] = commentsReplyMapArray
                                                                                            loopCommentsArray(c+1)
                                                                                          }
                                                                                        }

                                                                                        loopCommentsReplyArray(0)


                                                                                      } else {
                                                                                        loopCommentsArray(c+1)
                                                                                      }
                                                                                    })
                                                                                  })
                                                                                })

                                                                              } else {


                                                                                mediaMapArray.unshift({
                                                                                  mediaURI: res,
                                                                                  mediaFileName: thisFileName,
                                                                                  mediaItemCaption: caption,
                                                                                  uploadTimestamp: uploadTimestamp,
                                                                                  likesArray: likesArray,
                                                                                  commentsMapArray: commentsMapArray,
                                                                                  publisherUsername: managerDisplayName,
                                                                                })
                                
                                                                                mediaMapArray.sort(function(a,b) {
                                                                                    return (b.uploadTimestamp - a.uploadTimestamp)
                                                                                });

                                                                                loopUserMediaArray(m+1)

                                                                              }
                                                                            }
                                                                            loopCommentsArray(0);

                                                                        }
                                                                    })
                                                                    
                                                                }
                                                            }).catch((err)=>{
                                                              loopUserMediaArray(m+1)
                                                            })
                                                          } else {
                                                            mediaMapArrayUserMap[manager] = mediaMapArray
                                                        
                                                            that.setState({
                                                              mediaMapArrayUserMap
                                                            })
                                                            buildContractMapArrays()
                                                          }
                                                        }
                                                      } else {

                                                        bioString = 'No Bio :('
                                                      }
                                                    })
                                                  }


                                                  function buildContractMapArrays(){


                                                    authenticatedPut('api1169ba1e', '', { 
                                                      headers: { Authorization: `Bearer ${cognitoID}` },
                                                      body: { 
                                                        category: 'db',
                                                        tableName: 'users', 
                                                        primaryKey: manager, 
                                                        requestOperation: 'get',
                                                      }
                                                    }).then((userData) => {
                                                  
                                                      
                              
                                                      Promise.resolve().then(() => {
if (userData.Item.isSubscribedCurrentBool === true) {
                                                                    
                                                                    isSubscribedCurrentBool = true
                                                                    
                                                                  } else {
                                                                    
                                                                    isSubscribedCurrentBool = false
                                                                    
                                                                  }
});

                                                            let firstName = userData.Item.firstName ?? ''
                                                            let lastName = userData.Item.lastName ?? ''

                                                            let fullName = firstName.substring(0,1).toUpperCase()+firstName.substring(1,firstName.length) + ' ' + lastName.substring(0,1).toUpperCase()+lastName.substring(1,lastName.length)
                                                            
                                                            let price_usd = 1;

                                                            let _totalRepaid_nonConvert = parseFloat(userData.Item.totalPaid, 10)/1000000000000000000
                                                            let _borrowingRec_nonConvert = parseFloat(userData.Item.totalWithdrawn, 10)/1000000000000000000
                                                            let _joinDateSecs = userData.Item.joinDateSecs
                                                          
                                                            let raters = userData.Item.raters;
                                                            let ratingsMap = userData.Item.ratingsMap;
                                                            let ratingSum = 0;


                                                            for(let r=0; r<=raters.length-1; r++){
                                                              ratingSum += ratingsMap[raters[r]].rating
                                                            }

                                                            userAvgRating = (ratingSum/raters.length).toFixed(1)
                                                            if(_borrowingRec_nonConvert == 0){
                                                              blenderScore = 400
                                                            } else {
                                                              blenderScore = Math.ceil( 500 * (_totalRepaid_nonConvert/_borrowingRec_nonConvert) + 400 ) 
                                                            }     
                                                            
                                                            let values = [['Date', 'Avail. Balance']]
                                                            let firstDayValueFound = false;
                                                            let firstDayValue;
                                                            let firstDayValueIndex;
                                                            let firstDayValueDelta;
                                                            let lastDayValueFound = false;
                                                            let lastDayValue;
                                                            let lastDayValueIndex;
                                                            let previousDayValue1 = 'null';
                                                            let previousDayValueIndex;
                                                            let allZeroValues = [['Date', 'Avail. Balance'],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0],['null', 0]]
                                                
                                                            for(let j=0; j<=timeArray.length-1; j++){
                                                              function iffer(i){
                                                                if(i == timeArray.length-1){
                                                                  if(previousDayValue1 != 'null'){
                                                                    lastDayValueFound = true
                                                                    lastDayValue = previousDayValue1
                                                                    lastDayValueIndex = previousDayValueIndex
                                                                  } else {
                                                                    values = allZeroValues
                                                                  }
                                                                }
                                                              }
                                                              
                                                              if(scopedContractData.hasOwnProperty('interactions')){
                                                                if(scopedContractData.interactions.hasOwnProperty(timeArray[j])){
                                                                  previousDayValue1 = scopedContractData.interactions[timeArray[j]].value
                                                                  previousDayValueIndex = j
                                                                  if(firstDayValueFound == false){
                                                                    firstDayValueFound = true
                                                                    firstDayValue = scopedContractData.interactions[timeArray[j]].value
                                                                    firstDayValueDelta = scopedContractData.interactions[timeArray[j]].valueDelta
                                                                    firstDayValueIndex = j

                                                                    iffer(j)
                                                                  } else {
                                                                    iffer(j)
                                                                  }
                                                                } else {
                                                                  iffer(j)
                                                                }
                                                              } else {
                                                                iffer(j)
                                                              }
                                                            
                                                            }
                                                

                                                            let xMax = 0;
                                                            let xMin = 0;

                                                            if(values.length <= 1){
                                                              let previousDayValue2
                                                              for(let b=0; b<=timeArray.length-1; b++){
                                                                if(b < firstDayValueIndex){
                                                                  values.push(['null', Number(firstDayValue) - Number(firstDayValueDelta)])
                                                                } else if(b == firstDayValueIndex){
                                                                  values.push(['null', Number(firstDayValue)])
                                                                  previousDayValue2 = firstDayValue
                                                                } else if(b >= lastDayValueIndex){
                                                                  values.push(['null', Number(lastDayValue)])
                                                                } else if(b > firstDayValueIndex && b < lastDayValueIndex){
                                                                  if(scopedContractData.interactions.hasOwnProperty(timeArray[b])){
                                                                    values.push(['null', Number(scopedContractData.interactions[timeArray[b]].value)])
                                                                    previousDayValue2 = scopedContractData.interactions[timeArray[b]].value
                                                                  } else {
                                                                    values.push(['null', Number(previousDayValue2)])
                                                                  }
                                                                }
                                                                if(values[values.length-1][1] > xMax){
                                                                  xMax = values[values.length-1][1];
                                                                } else if(values[values.length-1][1] < xMin){
                                                                  xMin = values[values.length-1][1];
                                                                }
                                                              }
                                                            }

                                                            for(let k=0; k<=values.length-2; k++){
                                                              if(k != 0){
                                                                valueDeltas += Math.abs(parseInt(values[k][1], 10) - parseInt(values[k-1][1], 10))
                                                              } else {
                                                                valueDeltas += 0
                                                              }
                                                            }
                                                      
                                                            valueDeltas = parseInt(valueDeltas, 10)
                                                            contributionAvg = contributionSum/contributions.length
                                                            contributionAvg = contributionAvg || 0


                                                              if(!creditLineArray.includes(scopedContract)){
                                                                if(contractStructure == 'creditLine'){
                                                                  allBorrowerUsernamesDisplayNames.push(
                                                                    {
                                                                      id: allBorrowerUsernamesDisplayNames.length,
                                                                      name: manager
                                                                    }
                                                                  )
                                                                  if(managerDisplayName != manager){
                                                                    allBorrowerUsernamesDisplayNames.push(
                                                                      {
                                                                        id: allBorrowerUsernamesDisplayNames.length,
                                                                        name: managerDisplayName
                                                                      }
                                                                    )
                                                                  }
                                                                  

                                                                  creditLineArray.push({
                                                                    xMax,
                                                                    xMin,
                                                                    isSubscribedCurrentBool,
                                                                    address: scopedContract, 
                                                                    contractLookupID: lookupKey,
                                                                    activityAvg: contributionAvg, 
                                                                    deltaSum: valueDeltas, 
                                                                    blenderScore, 
                                                                    userAvgRating,
                                                                    displayName: managerDisplayName,
                                                                    fullName,
                                                                    manager, 
                                                                    intRate: intRate + ' %', 
                                                                    totalContributed, 
                                                                    balance: availableCredit, 
                                                                    values,
                                                                    lenderCt,
                                                                    receiptCount,
                                                                    contractBoxColor,
                                                                    contractBoxBorderColor,
                                                                    contractTextColor1,
                                                                    contractTextColor2,
                                                                    isCorporateBondBool,
                                                                    profilePicture_base64,
                                                                    profilePicture_uri,
                                                                    bioString,
                                                                  })
                                                                  creditLineAddressArray.push(scopedContract)
                                                                } 
                                                                if(recentlyViewedContracts.includes(scopedContract) && recentlyViewedContractsArray.length < 11){
                                                                  recentlyViewedContractsArray.push({
                                                                    xMax,
                                                                    xMin,
                                                                    isSubscribedCurrentBool,
                                                                    address: scopedContract, 
                                                                    contractLookupID: lookupKey,
                                                                    activityAvg: contributionAvg, 
                                                                    deltaSum: valueDeltas, 
                                                                    blenderScore, 
                                                                    userAvgRating,
                                                                    fullName,
                                                                    displayName: managerDisplayName,
                                                                    manager, 
                                                                    intRate: intRate + ' %', 
                                                                    totalContributed, 
                                                                    balance: availableCredit, 
                                                                    values,
                                                                    lenderCt,
                                                                    receiptCount,
                                                                    contractBoxColor,
                                                                    contractBoxBorderColor,
                                                                    contractTextColor1,
                                                                    contractTextColor2,
                                                                    isCorporateBondBool,
                                                                    profilePicture_base64,
                                                                    profilePicture_uri,
                                                                    bioString,
                                                                  })
                                                                }
                                                              

                                                                if(userWishlist.includes(scopedContract)){
                                                                  wishlistArray.push({
                                                                    xMax,
                                                                    xMin,
                                                                    isSubscribedCurrentBool,
                                                                    address: scopedContract, 
                                                                    contractLookupID: lookupKey,
                                                                    activityAvg: contributionAvg, 
                                                                    deltaSum: valueDeltas, 
                                                                    blenderScore, 
                                                                    userAvgRating,
                                                                    displayName: managerDisplayName,
                                                                    fullName,
                                                                    manager, 
                                                                    intRate: intRate + ' %',
                                                                    fontSize_intRate: 14, 
                                                                    left: 66, 
                                                                    top: 4, 
                                                                    totalContributed, 
                                                                    balance: availableCredit, 
                                                                    values,
                                                                    lenderCt,
                                                                    receiptCount,
                                                                    contractBoxColor,
                                                                    contractBoxBorderColor,
                                                                    contractTextColor1,
                                                                    contractTextColor2,
                                                                    isCorporateBondBool,
                                                                    profilePicture_base64,
                                                                    profilePicture_uri,
                                                                    bioString,
                                                                  })          
                                                                }
                                                              }

                                                              allContractsLooper--  
                                                              // if(allContractsLooper == 0){
                                                                that.updateContents()
                                                              // }
                                                          
                                                    })

                                                }
                                              }).catch((err) => {
                                              })
                                          })
                                        })
                                      })
                              })
                            }
                          }     
                        }
                      })
                    })
                })
              } else {
                allContractsLooper--
              }
            }
        })

      })
    });

  }

  shareCode(searchedContactSelected, contactSelected){    
      
    let email_or_phone = null
    let successText 
    let messageText = String(that.state.sharePromoString)


    let emailAddress_phoneNumber;
    let phNum = that.state.emailAddress_phoneNumber

    if( (phNum.length == 10 && !isNaN(phNum.substr(5,4)) && phNum.substr(0,1) != '+') || (phNum.length >= 12 && phNum.substr(0,1) == '+' && !isNaN(phNum.substr(phNum.length-5,4)))){
        let emailAddress_phoneNumber_edited
        phNum = phNum.replace('(','')
        phNum = phNum.replace(')','')
        phNum = phNum.replace('(','')
        phNum = phNum.replace(')','')
        phNum = phNum.replace('-','')
        phNum = phNum.replace('-','')
        phNum = phNum.replace('-','')
        phNum = phNum.replace(/\s+/g, '');

        if(that.state.emailAddress_phoneNumber.includes('@') && that.state.emailAddress_phoneNumber.includes('.')){
          email_or_phone = 'email'
          successText = String("Your Promo Code has been emailed to\n\n"+ that.state.emailAddress_phoneNumber.toLowerCase() +"")
        } 

        if(email_or_phone ==  'email'){

            let paramsMember = {
                Destination: {
                    ToAddresses: [that.state.emailAddress_phoneNumber]
                },
                Message: {
                    Body: {
                        Text: { 
                            Data: messageText
                        }
                    },
                    
                    Subject: { 
                      Data: that.state.selectedLanguage == 'spanish' ? 
                        'Unirte a Blender!'
                          :
                        'Sign up for Blender!'
                    }
                },
                Source: "admin@theblenderplatform.io"
            };
            var ses = new AWS.SES();

            ses.sendEmail(paramsMember, function (err, data) {
                if (!err){
                    
                    that.setState({
                        successOverlay: true,
                        successText
                    })
                    setTimeout(() => {
                        that.setState({
                            successOverlay: false,
                            emailAddress_phoneNumber: '',
                        })
                    }, 5000)
                }
            });

        } 
    }
  }

  shareViaMedia(){
    let messageText = String(that.state.sharePromoString)
    navigator.clipboard.writeText(messageText)
  }

  setNativeNotification(generalNoticeText){
    that.setState({
      generalNoticeOverlay: true,
      generalNoticeText
    })
  }

  render(){
      applicantUsername = that.props.username
    
      const { touched } = that.state;
      const className = touched ? 'button1_touched' : 'button1';

      if(navigationHandler(that.state.navigationDestinationObject)){
          return navigationHandler(that.state.navigationDestinationObject)
      }
      const renderProps = { API, AWS, Amplify, Auth, Browser, Button, ButtonContent, ButtonGroup, CampaignContract_latest, CampaignFactoryContract_latest, Chart, Component, Container, CryptoJS, ErrorBoundary, Form, FormField, Fragment, Header, Icon, Image, LENDERBLOCKADMINWHITELIST, LeftNavBar, Link, List, ListContent, ListDescription, ListHeader, ListIcon, ListItem, ListList, LoadingIcons, Modal, Mosaic, OrbitProgress, PIXELAJUST, Radio, React, ReactSearchAutocomplete, Storage, ThreeDot, USDEtherConversionRate, Web3, addedContracts, addedContracts_creditLine, addedContracts_loanAgreement, allBorrowerUsernamesDisplayNames, allContracts, allContractsLooper, allDaysElapsed, allValues, applicantUsername, awsconfig, axios, bScoreFilterMax, bScoreFilterMin, blenderCommissionPublicKey, blenderData, blenderPrivateKey, blenderScore, blenderTransfersToPublicKey, buttonColorFlashIntervalDefault, cardEntryFormTimer, cardFundComponent, chartData, chartDayRange, checkValidAuthTokenInterval, checkValidAuthTokenIntervalPeriod_ms, city, className, cognitoID, compoundedDebtSum, corporateBackedUsernamesArray, country, countryCodeSwappedJSON, countryCodeSwappedJSONList, countryCodes, countryNames, creditLineAddressArray, creditLineArray, currentLentSum, currentUser, currentUserCap, debounce, emailAddress, ethers, exitFundWalletTimer, exitTutorialTimer_1, exitTutorialTimer_2, exitTutorialTimer_3, filterSwitch, filterSwitchReloaded, firstName, flashCounter, forexJSON, fullAddress, fullName, fundWalletPromptDidBool, highRateWeb3, intRateMax, intRateMin, isMobile, isSubscribedCurrentBool, joinDateSecs, lastName, lastNonce, lenderCtMax, lenderCtMin, lenders, loanAgreementArray, mediaArray, mediaArrayMap, mediaMapArrayUserMap, mimemessage, mode_light_dark, monthLengtheningEnum, navigationHandler, newMemberRegisterBool, noAccountsWarning_creditLine, noAccountsWarning_loanAgreement, notificationCount, notifs, openBorrowingContractsDetails_loanAgreement, openContracts, openLendingContractsDetails_loanAgreement, openStakingContractsDetails_loanAgreement, optionCountryCodeSwappedJSON, pageOrigin, postalCode, preSortedContractsArray, primaryDisplayCurrency, primaryDisplayPrice, primaryLanguage, privateKey, proposeGasPrice, publicKey, rand1, rand2, rand3, rand4, randSum, ratingMax, ratingMin, recentlyViewedContracts, recentlyViewedContractsArray, resultMessageTimer, retrievedContractsArray, routeProps, scrollHeaderInterval, searchTimer, secondaryDisplayCurrency, secondaryDisplayPrice, squareCustomerID, stakedContractsList, state, street, that, tokenID, tokenLifeTimeLimit, topMoversArray, totalBorrContracts, touched, useLayoutEffect, useParams, useRef, userWishlist, username_wallet, verifyOverlayShownBool, walletBalance, walletBalanceWei, web3, wishlistArray };

      if (isMobile) {
        return <BrowserMobileRender {...renderProps} />;
      }

      return <BrowserDesktopRender {...renderProps} />;
    }

}


function Browser(props){
  const {username} = useParams();

  return (
    <ErrorBoundary>
      <BrowserComponent username={username}/>
    </ErrorBoundary>
  )
}

export default Browser;

